import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/vercel/path0/next/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPostRows"] */ "/vercel/path0/next/src/app/components/blog-post-row.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/app/images/empty-image.jpg");
